import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';
import { variables } from '../../../assets/styles/variables';
import themeColors from '../../../assets/styles/themeColors';
import { ReactComponent as InfoIcon } from '../../../assets/images/svg/info-bg.svg';
import { ReactComponent as CloseIcon } from '../../../assets/images/svg/close.svg';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(-4px);
  }
`;

const AUTO_CLOSE_DELAY = 7000;
const ANIMATION_DURATION = 300;

const SuccessToastWrapper = styled.div`
  border-radius: ${variables.borderRadius.borderRadius};
  box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.24);
  background-color: ${themeColors.colorWhite};
  position: absolute;
  top: 20px;
  left: 16px;
  right: 16px;
  margin: 0 auto;
  overflow: hidden;
  z-index: 1;
  animation: ${({ isClosing }) => (isClosing ? fadeOut : fadeIn)} 300ms ease
    forwards;
`;

const SuccessToastContent = styled.div`
  position: relative;
  padding: 16px 16px 16px 0;
  display: flex;
  align-items: center;
  flex-grow: 1;

  > svg {
    margin-left: 16px;
    margin-right: 12px;
  }
`;

const InfoPopunPattern = styled.div`
  width: 6px;
  height: 100%;
  position: absolute;
  border-radius: 4px 0 0 4px;
  background-color: ${themeColors.colorSuccess};
`;

const CloseIconWrapper = styled.div`
  cursor: pointer;
  width: 14px;
  height: 14px;
  margin-left: auto;
`;

const SuccessToastTitle = styled.p`
  font-size: 16px;
  font-weight: 500;
  color: ${themeColors.colorTextPrimary};
  margin-bottom: 2px;
  display: flex;
  flex: 1;
`;

const SuccessToastMessage = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: ${themeColors.colorTextSecondary};
`;

const SuccessToastInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

const SuccessToast = ({ isOpen, onClose, title, message }) => {
  const [isClosing, setIsClosing] = useState(false);
  useEffect(() => {
    if (!isOpen) return;

    const timer = setTimeout(() => {
      handleClose();
    }, AUTO_CLOSE_DELAY);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  const handleClose = () => {
    setIsClosing(true);

    setTimeout(() => {
      setIsClosing(false);
      onClose();
    }, ANIMATION_DURATION);
  };

  if (!isOpen && !isClosing) return null;

  return (
    <SuccessToastWrapper isClosing={isClosing}>
      <SuccessToastContent>
        <InfoPopunPattern />
        <InfoIcon />
        <SuccessToastInfo>
          {title && <SuccessToastTitle>{title}</SuccessToastTitle>}
          {message && <SuccessToastMessage>{message}</SuccessToastMessage>}
        </SuccessToastInfo>
        <CloseIconWrapper onClick={handleClose}>
          <CloseIcon />
        </CloseIconWrapper>
      </SuccessToastContent>
    </SuccessToastWrapper>
  );
};

SuccessToast.propTypes = {
  onClose: PropTypes.func,
  title: PropTypes.string,
  message: PropTypes.string,
  isOpen: PropTypes.bool,
};

export default SuccessToast;
